module.exports = __webpack_public_path__ + "static/media/flixbus-bg.c85d6836.jpg";